import { render, staticRenderFns } from "./InvestmentTypeSelection.vue?vue&type=template&id=dbf92402&scoped=true&"
import script from "./InvestmentTypeSelection.vue?vue&type=script&lang=ts&"
export * from "./InvestmentTypeSelection.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentTypeSelection.vue?vue&type=style&index=0&id=dbf92402&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf92402",
  null
  
)

export default component.exports